import { render } from "./ModalImagen.vue?vue&type=template&id=7082359e&scoped=true"
import script from "./ModalImagen.vue?vue&type=script&lang=js"
export * from "./ModalImagen.vue?vue&type=script&lang=js"

import "./ModalImagen.vue?vue&type=style&index=0&id=7082359e&scoped=true&lang=css"

import exportComponent from "/srv/repos/ayuda/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7082359e"]])

export default __exports__